import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import './admin.css';

const AdminLayout = ({ children }) => {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin');
  };

  const menuItems = [
    { path: '/admin/dashboard', label: 'Tableau de bord', icon: '📊' },
    { path: '/admin/sections', label: 'Sections (Livres)', icon: '📚' },
    { path: '/admin/author', label: 'L\'autrice', icon: '✍️' },
    { path: '/admin/testimonials', label: 'Avis', icon: '💬' },
    { path: '/admin/pricing', label: 'Prix', icon: '💰' },
    { path: '/admin/servicederelecture', label: 'Service de relecture', icon: '📖' },
    { path: '/admin/contact', label: 'Contact', icon: '📧' },
  ];

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <h2>UDAD Admin</h2>
          <span className="admin-user-email">{admin?.email}</span>
        </div>

        <nav className="admin-nav">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `admin-nav-item ${isActive ? 'active' : ''}`
              }
            >
              <span className="admin-nav-icon">{item.icon}</span>
              <span className="admin-nav-label">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          <a href="/" className="admin-nav-item" target="_blank" rel="noopener noreferrer">
            <span className="admin-nav-icon">🌐</span>
            <span className="admin-nav-label">Voir le site</span>
          </a>
          <button onClick={handleLogout} className="admin-nav-item admin-logout-btn">
            <span className="admin-nav-icon">🚪</span>
            <span className="admin-nav-label">Déconnexion</span>
          </button>
        </div>
      </aside>

      <main className="admin-main">
        <div className="admin-content">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;

